$('.expand-button').on('click', function () {
	$(this).closest('.card').toggleClass('show-expanded-text');
});
